// extracted by mini-css-extract-plugin
module.exports = {"labelRename":"RenameModal_labelRename__23wqv","groupBtn":"RenameModal_groupBtn__1iN8Z","requiredText":"RenameModal_requiredText__23x0p"};